(function () {
  function autoRotateAnnouncements() {
    var wrap = document.querySelector('.announcement-bar__slider');
    if (!wrap) return;
    var nextBtn = wrap.querySelector('.slideshow-control--next');
    if (!nextBtn) return;
    var SEGUNDOS_ENTRE_CAMBIOS = 5;
    setInterval(function () { nextBtn.click(); }, SEGUNDOS_ENTRE_CAMBIOS * 1000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoRotateAnnouncements);
  } else { autoRotateAnnouncements(); }
})();